import Step1 from './Step1';
import Step2 from './Step2';

export const steps = [
  {
    label: 'Deal Information',
    Content: Step1,
  },
  {
    label: 'Additional Information',
    Content: Step2,
  },
];

export const METADATA_FIELDS = [
  'dealId',
  'id',
  'createdDate',
  'createdAt',
  'createdBy',
  'createdByName',
  'lastModifiedDate',
  'updatedAt',
  'companyName',
];
